import Footer from "../Fotter";
import React from "react";
import logo from "../../websitecomponents/assets/flip-removebg-preview.png";

const ContactUs = () => {
  return (
    <div className="flex flex-col min-h-screen bg-white text-gray-800">
      <main className="flex-grow flex items-center justify-center px-4 py-10">
        <div className="w-[90%] bg-white  p-6 md:p-10 ">
          <h1 className="text-4xl font-bold mb-8 text-center text-black">
            Contact Us
          </h1>

          <div className="space-y-6 text-lg leading-relaxed ">
            <div>
              <h2 className=" font-bold"> Office and Warehouse Location:</h2>
              <p>
                403, Shagun Tower, Above Apna Sweets, Scheme Number 54,P.u.4,AB
                Rd,vijay Nagar,Indore,Madhy Pradesh 452010 Pradesh
              </p>
            </div>

            <div>
              <h2 className="font-bold"> Email:</h2>
              <p classname="hover:text-blue-600">info@bharatcod.com </p>

              <p>(We try to reply to every query within 24 working hours)</p>
            </div>

            <div>
              <h2 className="font-bold"> Call:</h2>
              <p> (+91) 9399456176</p>
            </div>

            <div>
              <h2 className="font-bold"> Website:</h2>
              <p>https://www.bharatcod.com</p>
            </div>
          </div>
          <div className="mt-10 flex  space-x-6">
            <a
              href="https://www.facebook.com/thebharatcod"
              target="_blank"
              rel="noopener noreferrer"
            >
              <i className="fab fa-facebook fa-2x text-blue-600 hover:text-blue-800"></i>
            </a>
            <a
              href="https://www.instagram.com/bharatcod/#"
              target="_blank"
              rel="noopener noreferrer"
            >
              <i className="fab fa-instagram fa-2x text-pink-500 hover:text-pink-700"></i>
            </a>
            <a
              href="https://in.pinterest.com/thebharatcod/"
              target="_blank"
              rel="noopener noreferrer"
            >
              <i className="fab fa-pinterest fa-2x text-blue-700 hover:text-blue-900"></i>
            </a>
            <a
              href="https://www.youtube.com/channel/UC5TRs6-BjCd9QgDbP8YKvEQ"
              target="_blank"
              rel="noopener noreferrer"
            >
              <i className="fab fa-youtube fa-2x text-red-700 hover:text-red-700"></i>
            </a>
          </div>
        </div>
      </main>

      <Footer />
    </div>
  );
};

export default ContactUs;
